import { useState, useEffect } from "react";
import { Layout } from "antd";
import { DevicePreviewContext } from "../../contexts/device-preview-context";

import useMediaQueries from "../../hooks/useMediaQueries";
import PreviewPageHeader from "./PreviewPageHeader";
import SiderCompetitionsMenu from "./SiderCompetitionsMenu";
import useNavigationParams from "../../hooks/useNavigationParams";

const { Content, Footer } = Layout;

const styles = {
  container: {
    minHeight: "100vh",
  },
  content: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    paddingTop: 30,
    paddingBottom: 30,
  },
  footer: {
    textAlign: "center",
  },
};

function PreviewPage() {
  const { searchParams } = useNavigationParams();
  const [selectedWidget, setSelectedWidget] = useState(searchParams.widget);
  const [competitionId] = useState(searchParams.competitionId);

  const { isDesktopOrLaptop } = useMediaQueries();

  const widgetURL = `${process.env.REACT_APP_ROOT_DOMAIN}/${selectedWidget}?competition=${competitionId}`;

  useEffect(() => {
    setSelectedWidget(searchParams.widget);
  }, [searchParams.widget]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <PreviewPageHeader />
      <Layout>
        {isDesktopOrLaptop ? <SiderCompetitionsMenu /> : null}

        <Layout>
          <DevicePreviewContext.Consumer>
            {({ previewDevice }) => (
              <Content style={styles.content}>
                <iframe
                  title="widget"
                  src={widgetURL}
                  style={{
                    backgroundColor: "#fff",
                    border: 0,
                    ...previewDevice.style,
                  }}
                />
              </Content>
            )}
          </DevicePreviewContext.Consumer>

          <Footer style={styles.footer}>Copyright ©2023 Ondebrief</Footer>
        </Layout>
      </Layout>
    </Layout>
  );
}

export default PreviewPage;
